import { SidePanel } from '@wix/design-system';
import classNames from 'classnames';
import React__default from 'react';
import { UiComponentsProvider } from '../../ui-components-provider.js';
import { ROOT } from './data-hooks.js';

const FloatingDesktopLayout = ({
  onCancel,
  content,
  dataHook
}) => {
  return /* @__PURE__ */ React__default.createElement(UiComponentsProvider, null, /* @__PURE__ */ React__default.createElement(
    SidePanel,
    {
      skin: "floating",
      width: "360px",
      onCloseButtonClick: onCancel,
      dataHook: classNames(ROOT, dataHook)
    },
    /* @__PURE__ */ React__default.createElement(SidePanel.Content, { noPadding: true }, content)
  ));
};

export { FloatingDesktopLayout };
//# sourceMappingURL=floating-desktop-layout.js.map
